var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.9493C17 18.2043 14.382 20.0713 12.359 20.7003C11.927 20.8343 11.644 20.3313 11.902 19.9603C12.782 18.6953 13.8 16.7653 13.8 14.9493C13.8 12.9993 12.156 10.6953 10.872 9.2753C10.579 8.9503 10.067 9.1653 10.051 9.6033C9.998 11.0523 9.769 12.9913 8.783 14.5103C8.74816 14.5672 8.70003 14.6147 8.64276 14.6489C8.58549 14.683 8.52079 14.7028 8.45421 14.7064C8.38762 14.71 8.32115 14.6975 8.2605 14.6697C8.19985 14.642 8.14683 14.6 8.106 14.5473C7.798 14.1573 7.49 13.6753 7.182 13.2953C7.016 13.0903 6.716 13.0883 6.525 13.2693C5.778 13.9763 4.733 15.0783 4.733 16.4493C4.733 17.4393 5.205 18.6693 5.691 19.6233C5.911 20.0563 5.502 20.5643 5.081 20.3213C3.246 19.2583 1 17.0563 1 13.9493C1 10.8033 5.31 6.4443 6.956 2.3263C7.216 1.6763 8.016 1.3713 8.573 1.7953C11.943 4.3633 17 9.3273 17 13.9493Z",
    fill: "#FF6A00",
    stroke: "#FF6A00",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeFire);
export default __webpack_public_path__ + "static/media/orangeFire.95f87580b3a3cdd6865c3bb845ca7369.svg";
export { ForwardRef as ReactComponent };